var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "50pt",
    viewBox: "0 -47 937.5 937",
    width: "50pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 62.5 844 L 812.5 844 C 847.015625 844 875 816.015625 875 781.5 L 875 734.625 C 875 725.992188 868.007812 719 859.375 719 L 828.125 719 L 828.125 484.625 L 796.875 484.625 L 796.875 719 L 765.625 719 L 765.625 500.25 L 734.375 500.25 L 734.375 719 L 533.09375 719 C 516.453125 718.945312 501.230469 728.367188 493.84375 743.265625 C 491.710938 747.558594 487.328125 750.257812 482.53125 750.25 L 392.46875 750.25 C 387.671875 750.257812 383.289062 747.558594 381.15625 743.265625 C 373.769531 728.367188 358.546875 718.945312 341.90625 719 L 140.625 719 L 140.625 265.875 L 437.5 265.875 L 437.5 234.625 L 125 234.625 C 116.367188 234.625 109.375 241.617188 109.375 250.25 L 109.375 719 L 78.125 719 L 78.125 250.25 C 78.125 224.367188 99.117188 203.375 125 203.375 L 437.5 203.375 L 437.5 172.125 L 125 172.125 C 81.875 172.179688 46.929688 207.125 46.875 250.25 L 46.875 719 L 15.625 719 C 6.992188 719 0 725.992188 0 734.625 L 0 781.5 C 0 816.015625 27.984375 844 62.5 844 Z M 31.25 750.25 L 341.90625 750.25 C 346.703125 750.242188 351.085938 752.941406 353.21875 757.234375 C 360.605469 772.132812 375.828125 781.554688 392.46875 781.5 L 482.53125 781.5 C 499.171875 781.554688 514.394531 772.132812 521.78125 757.234375 C 523.914062 752.941406 528.296875 750.242188 533.09375 750.25 L 843.75 750.25 L 843.75 781.5 C 843.75 798.761719 829.761719 812.75 812.5 812.75 L 62.5 812.75 C 45.238281 812.75 31.25 798.761719 31.25 781.5 Z M 31.25 750.25 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 171.875 297.125 L 203.125 297.125 L 203.125 328.375 L 171.875 328.375 Z M 171.875 297.125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 234.375 297.125 L 265.625 297.125 L 265.625 328.375 L 234.375 328.375 Z M 234.375 297.125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 296.875 297.125 L 328.125 297.125 L 328.125 328.375 L 296.875 328.375 Z M 296.875 297.125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.75 390.875 L 468.75 359.625 L 187.5 359.625 C 178.867188 359.625 171.875 366.617188 171.875 375.25 L 171.875 469 C 171.875 477.632812 178.867188 484.625 187.5 484.625 L 562.5 484.625 L 562.5 453.375 L 203.125 453.375 L 203.125 390.875 Z M 468.75 390.875 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 171.875 656.5 L 281.25 656.5 L 281.25 687.75 L 171.875 687.75 Z M 171.875 656.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.5 656.5 L 421.875 656.5 L 421.875 687.75 L 312.5 687.75 Z M 312.5 656.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 453.125 656.5 L 562.5 656.5 L 562.5 687.75 L 453.125 687.75 Z M 453.125 656.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 593.75 656.5 L 703.125 656.5 L 703.125 687.75 L 593.75 687.75 Z M 593.75 656.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 421.875 531.5 C 421.875 522.867188 414.882812 515.875 406.25 515.875 L 328.125 515.875 C 319.492188 515.875 312.5 522.867188 312.5 531.5 L 312.5 609.625 C 312.5 618.257812 319.492188 625.25 328.125 625.25 L 406.25 625.25 C 414.882812 625.25 421.875 618.257812 421.875 609.625 Z M 390.625 594 L 343.75 594 L 343.75 547.125 L 390.625 547.125 Z M 390.625 594 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 281.25 531.5 C 281.25 522.867188 274.257812 515.875 265.625 515.875 L 187.5 515.875 C 178.867188 515.875 171.875 522.867188 171.875 531.5 L 171.875 609.625 C 171.875 618.257812 178.867188 625.25 187.5 625.25 L 265.625 625.25 C 274.257812 625.25 281.25 618.257812 281.25 609.625 Z M 250 594 L 203.125 594 L 203.125 547.125 L 250 547.125 Z M 250 594 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 687.5 625.25 C 696.132812 625.25 703.125 618.257812 703.125 609.625 L 703.125 531.5 C 703.125 522.867188 696.132812 515.875 687.5 515.875 L 609.375 515.875 C 600.742188 515.875 593.75 522.867188 593.75 531.5 L 593.75 609.625 C 593.75 618.257812 600.742188 625.25 609.375 625.25 Z M 625 547.125 L 671.875 547.125 L 671.875 594 L 625 594 Z M 625 547.125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 562.5 531.5 C 562.5 522.867188 555.507812 515.875 546.875 515.875 L 468.75 515.875 C 460.117188 515.875 453.125 522.867188 453.125 531.5 L 453.125 609.625 C 453.125 618.257812 460.117188 625.25 468.75 625.25 L 546.875 625.25 C 555.507812 625.25 562.5 618.257812 562.5 609.625 Z M 531.25 594 L 484.375 594 L 484.375 547.125 L 531.25 547.125 Z M 531.25 594 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 703.125 0.25 C 573.679688 0.25 468.75 105.179688 468.75 234.625 C 468.75 364.070312 573.679688 469 703.125 469 C 832.570312 469 937.5 364.070312 937.5 234.625 C 937.351562 105.242188 832.507812 0.398438 703.125 0.25 Z M 703.125 437.75 C 590.941406 437.75 500 346.808594 500 234.625 C 500 122.441406 590.941406 31.5 703.125 31.5 C 815.308594 31.5 906.25 122.441406 906.25 234.625 C 906.125 346.753906 815.253906 437.625 703.125 437.75 Z M 703.125 437.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 703.125 125.25 C 710.054688 125.324219 716.953125 126.054688 723.75 127.441406 L 700.65625 141.96875 L 717.3125 168.421875 L 770.046875 135.21875 C 773.707031 132.910156 776.246094 129.1875 777.0625 124.9375 C 777.882812 120.683594 776.894531 116.289062 774.34375 112.796875 L 735.9375 60.0625 L 710.667969 78.449219 L 723.171875 95.519531 C 682.769531 89.5 641.753906 101.421875 610.878906 128.15625 C 579.992188 154.890625 562.324219 193.78125 562.5 234.625 C 562.441406 263.527344 571.335938 291.730469 587.964844 315.363281 L 613.550781 297.40625 C 590.125 263.996094 587.25 220.335938 606.085938 184.140625 C 624.914062 147.949219 662.324219 125.246094 703.125 125.25 Z M 703.125 125.25 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.046875 170.035156 C 815.46875 203.433594 818.351562 247.105469 799.507812 283.300781 C 780.671875 319.492188 743.273438 342.195312 702.464844 342.183594 C 695.550781 342.105469 688.648438 341.375 681.859375 340 L 704.941406 325.449219 L 688.289062 299.019531 L 635.554688 332.222656 C 631.894531 334.527344 629.355469 338.238281 628.539062 342.496094 C 627.726562 346.742188 628.703125 351.140625 631.25 354.644531 L 669.652344 407.378906 L 694.921875 388.96875 L 682.421875 371.90625 C 737.898438 379.839844 792.792969 354.082031 822.144531 306.347656 C 851.488281 258.605469 849.695312 198 817.570312 152.078125 Z M 792.046875 170.035156 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.a36b94438a2b273438f69bbd877ffc1b.svg";
export { ForwardRef as ReactComponent };